import React from "react";

export default function AppTextArea({
  label,
  onChange,
  value,
  placeholder,
  error,
  errorText,
  rows,
  textAreaRef,
  defaultValue,
  className = "",
  textAreaLable="",
  isRequired ,
  errorClassName="",
}) {
  return (
    <div className="flex flex-col w-full">
      {label && (
        <label className={`mb-1 text-sm font-medium text-gray-700 ${textAreaLable}`}>
          {label}{isRequired ?<span className="text-red-500">*</span>:""}
        </label>
      )}

      <textarea
        ref={textAreaRef}
        rows={rows}
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className={`border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 placeholder-gray-400 resize-none ${error? "focus-within:ring-red-500 " : "focus-within:ring-blue-500 "} ${className}`}
      ></textarea>

      {error && value === "" &&  (
        <p className={` text-sm text-red-600 ${errorClassName}`}>{errorText}</p>
      )}
    </div>
  );
}
